<template>
  <!-- 退货审核页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        :title="orderStatus+'详情'"
        left-arrow
        @click-left="$router.back()"
      />
    </div>
    <div class="center">
      <div v-if="status == '7'" class="refundInfo refundInfos">
        <div class="refundStatus">
          <img :src="statusImg" alt="" />
          <h5>{{ statusTitle }}</h5>
          <span>退款到账时间以付款账户到账时间为准</span>
        </div>
      </div>
      <div v-else class="refundInfo">
        <div class="refundStatus">
          <img :src="statusImg" alt="" />
          <h5
            v-if="statusTitle == '验货未通过' || statusTitle == '审核未通过'"
            style="color:#F64B27"
          >
            {{ statusTitle }}
          </h5>
          <h5 v-else>{{ statusTitle }}</h5>
        </div>
        <van-steps
          active-icon="checked"
          finish-icon="checked"
          v-if="status == 12 ? false : true"
          :active="active"
          :class="stepShow ? 'van-steps' : 'van-stepShow'"
          inactive-icon="passed"
        >
          <van-step>提交申请</van-step>
          <van-step>{{
            statusTitle === "审核未通过" ? "审核未通过" : "审核通过"
          }}</van-step>
          <van-step v-if="orderStatus !== '退款'">寄回商品</van-step>
          <van-step v-if="orderStatus !== '退款'">{{
            statusTitle === "验货未通过" ? "验货未通过" : "宇起验货"
          }}</van-step>
          <van-step v-if="orderStatus == '退货'||orderStatus=='退款'">发起退款</van-step>
          <van-step v-if="orderStatus == '换货'">商家换货</van-step>
          <van-step v-if="status == 10">协商处理</van-step>
        </van-steps>
      </div>
      <div class="center-btn">
        <div class="auditProgress">
          <van-steps direction="vertical">
            <van-step @click.native="getAfteProcessStatus()">
              <p>
                {{ listTurnover.service_desc }}
              </p>
              <p class="LogisticsTime">{{ listTurnover.add_time }}</p>
            </van-step>
          </van-steps>
          <div class="auditProgressBtn">
            <van-button
              v-if="productInfoList.log_status !== 1 && status != '7'"
              size="small"
              round
              @click.stop="onClick"
              >撤销申请</van-button
            >
            <van-button
              size="small"
              class="fillInLogistics"
              round
              v-if="productInfoList.status == 2"
              @click="toFillLogistics"
              >填写物流单号</van-button
            >
            <van-button
              size="small"
              class="auditProgress"
              round
              v-if="
                productInfoList.status == 4 && productInfoList.is_fill_log != 1
              "
              @click="toFillLogistics"
              >修改物流单号</van-button
            >
          </div>
        </div>
        <van-field
          class="tkMoney"
          input-align="right"
          v-if="orderStatus == '退货'"
          label="退款金额"
          :value="'￥' + Number(this.productInfoList.money).toFixed(2)"
          readonly
        />
        <van-field
          input-align="right"
          v-if="orderStatus == '退货'"
          label="退款方式"
          value="退至付款账户"
          readonly
        />
        <van-field
          input-align="right"
          label="退货方式"
          v-if="orderStatus == '退货'"
          value="自寄退货"
          readonly
        />
        <!-- 物流数据 -->
        <div v-if="context" class="expressInformation" @click="toLogistics()">
          <van-loading
            style=" text-align: center;"
            type="spinner"
            v-show="loding"
          />
          <van-steps direction="vertical">
            <van-step>
              <p>
                {{ context }}
              </p>
              <p>{{ fstime }}</p>
            </van-step>
          </van-steps>
        </div>
        <!-- 商家地址 -->
        <div class="address">
          <div class="mobile">
            <span class="nameLeft">商家地址</span>
          </div>
          <p><van-icon name="phone-o" />宇起售后服务部 021-55220166</p>
          <p><van-icon name="location-o" />上海市黄浦区日月光中心3201室</p>
        </div>
        <!-- 产品信息 -->
        <ul>
          <li>
            <div
              @click="toShopping"
              class="productInfo"
              v-for="item in productInfo"
              :key="item.id"
            >
              <img :src="item.color_img" alt="" />
              <div class="title" style="color:#333">
                <p>{{ item.goods_detail_name }}</p>
                <div class="p2">
                  <span style="font-size:14px">{{ item.color_name }}</span
                  >
                  <span v-if="orderStatus=='退款'"  class="num" style="color:#666;font-size:0.32rem">共{{ item.num }}件</span>
                  <span v-else class="num" style="color:#666;font-size:0.32rem">共{{ item.refundNum }}件</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <van-cell-group class="info">
          <van-cell title="订单编号">
            <template #extra>
              <span id="bar">
                {{ record_code }}
              </span>
              <van-button
                :data-clipboard-text="record_code"
                class="btn"
                type="primary"
                @click="copy"
                size="mini"
                >复制</van-button
              >
            </template>
          </van-cell>
          <van-cell title="服务编号">
            <template #extra>
              <span id="bar">
                {{ service_code }}
              </span>
              <van-button
                :data-clipboard-text="service_code"
                class="btn"
                type="primary"
                @click="copy"
                size="mini"
                >复制</van-button
              >
            </template>
          </van-cell>
          <van-cell title="申请时间" :value="this.productInfoList.add_time" />
          <van-cell
            v-if="orderStatus == '退货' || orderStatus == '退款'"
            title="退货原因"
            class="ss"
            :value="this.productInfoList.service_reasion_type"
          />
          <van-cell
            v-if="orderStatus == '换货'"
            title="换货原因"
            :value="this.productInfoList.service_reasion_type"
          />
          <van-cell
            @click="descriptionShow = true"
            title="问题描述"
            class="ss"
            is-link
            :value="this.productInfoList.sale_desc"
          />
        </van-cell-group>
      </div>
    </div>
    <van-action-sheet v-model="descriptionShow" title="问题描述">
      <div class="tips">
        <div class="tipsText">
          <span>{{ this.productInfoList.sale_desc }}</span>
          <ul>
            <li v-for="(item, index) in this.FillLogistics" :key="index">
              <img v-if="imgShows" :src="item.image_url" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
// 点击复制的插件
import Clipboard from "clipboard";
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      loding: false,
      log_status: "",
      imgShows: true,
      statusImg: "",
      stepShow: true,
      statusTitle: "",
      status: "",
      active: 0,
      descriptionShow: false,
      orderCode: "",
      // 退货数据
      productInfo: {},
      productInfoList: {},
      listTurnover: {},
      FillLogistics: [],
      logisticsList: {},
      service_id: "",
      orderStatus: "",
      context: "",
      fstime: "",
      contextShow: false,
      record_code: "",
      // record_code:sessionStorage.getItem("orderCode"),
      LeavingAMessage: "",
      service_code: "",
    };
  },
  created() {
    this.getAddressList();
    this.getLogistics();
  },
  methods: {
    // 获取订单售后状态信息
    async getAddressList() {
      let service_id = this.$route.query.service_code;
      await this.$post({
        url: "/saleService/detail",
        method: "get",
        params: {
          service_id,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            switch (res.data.status) {
              case 1:
                this.active = 0;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7184@2x.png");
                break;
              case 2:
                this.active = 1;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7183@2x.png");
                break;
              case 3:
                this.active = 1;
                this.stepShow = false;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7179@2x.png");
                break;
              case 4:
                this.active = 2;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7181@2x.png");
                break;
              case 5:
                this.active = 3;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7182@2x.png");
                break;
              case 6:
                this.stepShow = false;
                this.active = 3;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7179@2x.png");
                break;
              case 7:
                this.active = 3;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7180@2x.png");
                break;
              case 8:
                this.stepShow = false;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7179@2x.png");
                break;
              case 9:
                this.stepShow = false;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7179@2x.png");
                break;
              case 10:
                this.active = 4;
                this.stepShow = false;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7181@2x.png");

                break;
              case 11:
                this.active = 4;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7181@2x.png");
                break;
              case 12:
                this.active = 3;
                this.statusTitle = res.data.listTurnover2.title;
                this.statusImg = require("../../assets/img/icon/组 7181@2x.png");
                break;
              default:
                break;
            }
            this.log_status = res.data.log_status;
            this.status = res.data.status;
            this.LeavingAMessage = res.data.buyRemark;
            this.productInfoList = res.data;
            if (this.productInfoList.imgList[0] == null) {
              this.imgShows = false;
            }
            this.service_code = res.data.service_code;
            this.productInfo = res.data.productInfo;
            this.record_code = res.data.record_code;
            this.orderStatus = this.productInfoList.service_mode;
            this.listTurnover = res.data.listTurnover2;
            this.FillLogistics = res.data.imgList;
          }
        })
        .catch((err) => {
          return;
        });
    },
    // 撤销申请
    onClick() {
      let service_id = this.$route.query.service_code;
      Dialog.confirm({
        title: "撤销申请",
        message:
          "您将撤销本次申请，如您修改退货方式或退货商品，撤销申请后可重新发起申请，确认继续吗？",
      })
        .then(() => {
          this.$post({
            url: "/saleService/cancellation",
            method: "post",
            params: {
              service_id,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已取消");
                let that = this;
                that.$router.back();
              } else {
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    // 跳转查看物流数据
    toLogistics() {
      this.$router.push({
        path: "/Logistics",
        query: {
          orderCode: this.record_code,
        },
      });
    },
    // 填写物流单号页面
    toFillLogistics() {
      this.$router.push({
        path: "/FillLogistics",
        query: {
          service_id: this.$route.query.service_code,
        },
      });
    },
    // 获取物流数据
    async getLogistics() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "/oor/findLOGByCode",
        method: "get",
        params: {
          recordCode: orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.loding = false;
            if (res.data.data2 !== undefined) {
              let AcceptStation = res.data.data2.reverse();
              this.context = AcceptStation[0].AcceptStation;
              this.fstime = AcceptStation[0].AcceptTime;
              this.contextShow = true;
            } else {
              // this.context = res.data.message;
              // console.log(this.context)
              this.contextShow = false;
            }
          } else {
            // this.$toast(res.message);
          }
        })
        .catch((err) => {
          // this.$toast(err.message);
        });
    },
    getAfteProcessStatus() {
      this.$router.push({
        path: "/AfteProcessStatus",
        query: {
          service_code: this.productInfoList.service_code,
        },
      });
    },
    toShopping() {
      sessionStorage.setItem("P_ID", this.productInfo[0].goods_id);
      this.$router.push("/toShopping");
    },
    copy() {
      var clipboard = new Clipboard(".btn");
      clipboard.on("success", (e) => {
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  position: relative;
  background: #eeeeee;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    background-color: #1f000000;
    padding-top: 1.2rem;
    .center-btn {
      margin: 0rem 0.27rem 0 0.27rem;
    }
    .refundInfo {
      // height: 3.65rem;
      height: auto;
      background-color: #fff;
      padding: 0.6rem 0.213333rem;
      box-sizing: border-box;
      .van-stepShow {
        display: none;
      }
      .van-steps {
        display: block;
      }
      span {
        font-size: 0.37rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .refundStatus {
        text-align: left;
        padding: 0 0.213333rem;
        img {
          display: inline-block;
          vertical-align: middle;
        }
        h5 {
          font-size: 0.48rem;
          display: inline-block;
          text-align: center;
          color: #000;
        }
      }
    }
    .refundInfos {
      height: 2.65rem;
      background-color: #fff;
      padding: 0.5rem 0;
      box-sizing: border-box;
      .van-stepShow {
        display: none;
      }
      .van-steps {
        display: block;
      }
      span {
        font-size: 0.37rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .refundStatus {
        text-align: left;

        img {
          width: 1rem;
          height: 1rem;
          display: inline-block;
          vertical-align: middle;
        }
        h5 {
          font-size: 0.48rem;
          display: inline-block;
          text-align: center;
          color: #000;
        }
        span {
          display: block;
          margin-left: 0.27rem;
          font-size: 0.37rem;
          color: #333;
        }
      }
    }
    .auditProgress,
    .expressInformation {
      overflow: hidden;
      margin: 0.27rem 0;
      background-color: #fff;
      box-sizing: border-box;
      .van-steps {
        background-color: #fff;
      }
      p {
        color: #333;
      }
      .LogisticsTime {
        margin-top: 0.27rem;
        color: #666666;
      }
      .van-steps {
        padding-left: 0.27rem;

        /deep/.van-step__circle-container {
          .van-icon {
            //  position: static;
            display: none !important;
          }
        }
      }
      .auditProgressBtn {
        box-sizing: border-box;
        float: right;
        .van-button {
          color: #fc563a;
          border-color: #fc563a;
          margin: 0.2rem 0.15rem;
        }
        .fillInLogistics {
          color: #000;
          border-color: #000;
        }
        .auditProgress {
          color: #fc563a;
          border-color: #fc563a;
        }
      }
    }
    /deep/.van-step--horizontal .van-step__icon {
      font-size: 0.4rem !important;
    }

    .tkMoney {
      margin-top: 0.27rem;
      /deep/.van-field__control {
        color: red !important;
      }
    }
    ul {
      li {
        margin-top: 0.27rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.08rem;
        .orderHeader {
          height: 1.12rem;
          line-height: 1.12rem;
          border-bottom: 1px solid #eeeeee;
          .orderTitle {
            float: left;
            font-size: 0.42rem;
            margin-left: 0.27rem;
          }
          .refund {
            float: right;
            font-size: 0.42rem;
            margin-right: 0.37rem;
          }
          span {
            font-size: 0.45rem;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .productInfo {
          display: flex;
          // align-items: center;
          padding: 0.4rem 0.4267rem;
          img {
            width: 2.7733rem;
            height: 2rem;
            object-fit: cover;
          }
          .title {
            width: 5rem;
            margin-left: 0.8rem;
            p {
              margin: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .p2 {
              margin-top: 0.6667rem;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }
        }
      }
    }
    .info {
      margin-top: 0.27rem;
      .ss {
        margin-top: 0 !important;
        .van-cell__value {
          /deep/span {
            width: 1rem !important;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
          }
        }
      }
      .van-button {
        padding: 0.053333rem 0.293333rem;
        vertical-align: middle;
        background-color: #fff;
        color: #333;
        border-color: #666;
        margin-left: 0.5rem;
        font-size: 0.32rem;
        border-radius: 1rem;
      }
      .van-cell__value {
        color: #333;
      }
    }
    .address {
      padding-left: 0.15rem;
      padding-bottom: 0.27rem;
      margin-top: 0.1rem;
      background-color: #fff;
      padding-top: 0.43rem;
      .mobile {
        padding: 0 0.27rem;
        margin-bottom: 0.27rem;
        overflow: hidden;
        font-size: 0.4rem;

        .nameLeft {
          float: left;
        }
        .mobileRight {
          position: relative;
          float: right;
          text-align: center;
          vertical-align: middle;
          color: #333;
          .van-icon {
            top: -0.04rem;
            font-size: 0.4rem;
            vertical-align: middle;
          }
        }
      }
      p {
        padding: 0.1rem 0.27rem;
        font-size: 0.4rem;
        i {
          color: #488dff;
          margin-right: 0.1rem;
          vertical-align: text-top;
        }
      }
      .addressInfo {
        padding: 0.3rem 0.27rem;
      }
    }
    .van-cell.van-cell--center {
      margin-left: 0.05rem;
    }
    .van-cell.van-cell--clickable {
      margin-top: 0.11rem;
    }
  }
  .tips {
    min-height: 6rem;
    padding: 0.5rem 0.5rem 1rem 0.5rem;
    overflow: hidden;
    background-color: #fff;
    .tipsText {
      span {
        font-size: 0.36rem;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        li {
          // float: left;
          margin-left: 0.5rem;
          margin-bottom: 0.4rem;
          img {
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 0.08rem;
          }
        }
      }
    }
  }
  /deep/.van-step--finish {
    color: #3bc95c;
  }
  /deep/.van-step--horizontal .van-step__title {
    margin-left: -0.45rem;
    font-size: 0.32rem;
    transform: scale(0.8);
    // margin-left: 0.1rem;
  }
  /deep/.van-step--horizontal:first-child .van-step__title {
    margin-left: -0.2667rem;
  }
  /deep/.van-step--horizontal:last-child .van-step__title {
    margin-right: -0.4533rem;
  }
  /deep/.van-steps--horizontal{
    padding: 0;
  }
  /deep/.van-steps__items {
    margin: 0 0.4rem;
  }
  // /deep/.van-steps .van-step__title{
  //   font-size: 0.32rem;
  //   transform: scale(0.8);
  // }
}
</style>
